import { Controller } from 'react-hook-form';
import { usePalette } from 'src/hooks';
import { MenuItem, TextField, Typography } from 'src/components/atoms';
import { FormFieldContainer, FormSelectProps } from './utils';

export const FormSelect = ({
  control,
  name,
  options,
  inputProps,
  defaultValue,
  rules,
  isError,
  errorMsg
}: FormSelectProps) => {
  const { error } = usePalette();

  return (
    <FormFieldContainer>
      <Controller
        render={({ field: { ref, ...field } }) => (
          <TextField select {...inputProps} {...field} inputRef={ref}>
            {options.map(option => (
              <MenuItem value={option.value} key={option.value}>
                {option.text}
              </MenuItem>
            ))}
          </TextField>
        )}
        name={name}
        defaultValue={defaultValue || ''}
        control={control}
        rules={rules}
      />
      {isError && (
        <Typography variant='body2' color={error.main} sx={{ ml: 2 }}>
          {errorMsg}
        </Typography>
      )}
    </FormFieldContainer>
  );
};
